import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-history-users',
  templateUrl: './history-users.component.html',
  styleUrls: ['./history-users.component.scss'],
})
export class HistoryUsersComponent implements OnInit {
  @ViewChild('infiniteScroll') infiniteScroll: InfiniteScroll;

  public users = [];
  public actualPage = 1;
  public totalPages = undefined;
  private month: any;
  private type: any;
  private search = "";
  public loaded = false;
  public rols = [
    {
      value: 'Enero',
      id: 1
    },
    {
      value: 'Febrero',
      id: 2
    },
    {
      value: 'Marzo',
      id: 3
    },
    {
      value: 'Abril',
      id: 4
    },
    {
      value: 'Mayo',
      id: 5
    },
    {
      value: 'Junio',
      id: 6
    },
    {
      value: 'Julio',
      id: 7
    },
    {
      value: 'Agosto',
      id: 8
    },
    {
      value: 'Septiembre',
      id: 9
    },
    {
      value: 'Octubre',
      id: 10
    },
    {
      value: 'Noviembre',
      id: 11
    },
    {
      value: 'Diciembre',
      id: 12
    },
  ]
  public items = [
    {
      id: 2,
      value: 'GiftCard',
    },
    {
      id: 1,
      value: 'Cupon',
    },
  ]
  @Output() emitItemSelected = new EventEmitter();
  constructor(private httpSv: HttpService) {}

  ngOnInit() {
    this.getUsers();
  }

  async getUsers() {
    const params = {
      pag: this.actualPage,
      month: this.month,
      search: this.search,
      type: this.type,
    };
    const res = await this.httpSv.itemIndex(
      'admin/giftCard/report',
      '',
      params,
      'index'
    );
    const data = res.data;
    this.loaded = true;
    if (!this.totalPages) this.totalPages = res.data.meta.last_page;
    this.users.push(...data.data);
  }

  async loadData(ev: InfiniteScroll) {
    if (this.totalPages >= this.actualPage) {
      ev.disconnect();
      this.actualPage++;
      await this.getUsers();
      ev.observe();
    } else {
      ev.complete();
    }
  }
  showItem(selectedItem) {
    this.emitItemSelected.emit(selectedItem);
  }
  searchData(ev) {
    if (ev.id || ev.id === '') {
      this.month = ev?.id;
    }
    if (ev.items || ev.items === '') {
      this.type = ev?.items;
    }
    this.infiniteScroll.setVisible();
    this.infiniteScroll.observe();
    this.actualPage = 1;
    this.search = ev?.value;
    this.users = [];
    this.totalPages = 1;
  }
}
